import './index_web.css';
import View from '../view';
import Text from '../text';
import React from 'react';
import useTheme from '../../utilities/hooks/theme';

interface Props {
  item: any;
}
const TransactionHeaderGameItemWeb = ({ item }: Props) => {
  const { AccountTheme: theme } = useTheme();
  const contentTextColor = {
    color: 'white'
  };
  const {
    game = '',
    entryFee = 0,
    gameId = '',
    matchTitle = null,
    totalEntryCount = 0,
    isPoker = false
  } = item;
  const gameItemTitleStyle = {
    background: theme.transactionHistoryGameItemTitleBg,
    boxShadow: theme.transactionHistoryGameItemTitleBoxShadow,
    color: 'white'
  };
  return (
    <View className={'transaction-header-game-item-container'}>
      <View className={'transaction-header-game-item-content-container'}>
        <Text className="transaction-header-game-item-title" style={gameItemTitleStyle}>
          {'Entry Fee'}
        </Text>
        <Text style={contentTextColor} className={'transaction-header-game-item-value'}>{`₹${
          entryFee / 100
        }/-`}</Text>
      </View>
      {!isNaN(totalEntryCount) && !isPoker && (
        <View className={'transaction-header-game-item-content-container'}>
          <Text style={gameItemTitleStyle} className="transaction-header-game-item-title">
            {'Entry Count'}
          </Text>
          <Text
            style={contentTextColor}
            className={'transaction-header-game-item-value'}>{`${totalEntryCount}`}</Text>
        </View>
      )}
      {matchTitle && (
        <View className={'transaction-header-game-item-content-container'}>
          <Text style={gameItemTitleStyle} className="transaction-header-game-item-title">
            {'Match Name'}
          </Text>
          <Text
            style={contentTextColor}
            className={'transaction-header-game-item-value'}>{`${matchTitle}`}</Text>
        </View>
      )}
      <View className={'transaction-header-game-item-content-container'}>
        <Text style={gameItemTitleStyle} className="transaction-header-game-item-title">
          {'Game Id'}
        </Text>
        <Text
          style={contentTextColor}
          className={'transaction-header-game-item-value'}>{`${gameId}`}</Text>
      </View>
      <View className={'transaction-header-game-item-content-container'}>
        <Text style={gameItemTitleStyle} className="transaction-header-game-item-title">
          {'Game'}
        </Text>
        <Text
          style={contentTextColor}
          className={'transaction-header-game-item-value'}>{`${game}`}</Text>
      </View>
    </View>
  );
};
export default React.memo(TransactionHeaderGameItemWeb);
